export const STRIPE_PUBLIC_KEY = "pk_live_5ylj12W0Ep0es6Og5EQKibbw00bjiV1eHH";
export const PAYPAL_CLIENT_ID =
    "AeTyw2u6-_iYMPxEpq2W4nb5ArsQSkDV6cLuFzIsVocyq5_1KKs-fZhd-LPjbsiyDXVremzRrezI7EXH";
export const API_LEVEL = "2.5.45";
